import React, { useState, useEffect, Fragment } from 'react';
import { AddButton } from '../../_Components';
import { GET_LIST,  provider } from '../../_utils';

import CreatDialog from './CreatDialog';

const ListActions = () => {
    const [openCreat, setOpenCreat] = useState(false);
    const [projects, setProjects] = useState([])

    useEffect(()=> {

        const  getProjects = async () => {
            const project = await provider( 
                GET_LIST,
                '/projects',
                {
                    filter: { status: 'Active' },
                    sort: { field: 'date', order: 'ASC' },
                    pagination: { page: 1, perPage: 1000 },
                }
            );
            setProjects(project.data);
        }
        if(projects.length===0){
            getProjects()
        }
    },[projects])
    const handleClickOpen = () => {
        setOpenCreat(true);
    }

    const handleCloseCreat = () => {
        setOpenCreat(false);
    }


    return(
        <Fragment>
            <AddButton 
                label={'Создать'}
                handleAddClick={handleClickOpen}
            />
             <CreatDialog handleCloseCreat={handleCloseCreat} openCreat={openCreat} projects={projects}/>
        </Fragment>
    )
};

export default ListActions;